import { Download } from 'lucide-react'
import { useCustomerTrackerStore } from '@/stores/customer-tracker-store'
import { useItemsBoardStore } from '@/stores/items-board-store'

export function DownloadDataButton() {
  const { customers, groupBoxes } = useCustomerTrackerStore()
  const { items } = useItemsBoardStore()

  const handleDownload = () => {
    // Gather all data
    const backupData = {
      exportedAt: new Date().toISOString(),
      version: '1.0',
      data: {
        customers,
        groupBoxes,
        goals: items,
      },
    }

    // Create JSON blob
    const blob = new Blob([JSON.stringify(backupData, null, 2)], {
      type: 'application/json',
    })

    // Create download link
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url

    // Filename with timestamp
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5)
    link.download = `office-tv-backup-${timestamp}.json`

    // Trigger download
    document.body.appendChild(link)
    link.click()

    // Cleanup
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  return (
    <button
      onClick={handleDownload}
      className="flex items-center gap-2 px-3 py-1.5 rounded text-sm font-medium transition-colors bg-white/[0.05] hover:bg-white/[0.1] text-white/80 hover:text-white border border-white/[0.1]"
      title="Download all data as JSON backup"
    >
      <Download className="w-4 h-4" />
      Backup Data
    </button>
  )
}
